import axios from 'axios';
import CryptoJS, { mode } from 'crypto-js';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import AdminSettingsService from './../../../services/adminsettings.service';
import {Validator} from 'vee-validate';
import CargoAllocationService from '../../../../cargoallocation/services/cargoallocation.service'
import MasterService from '../../../../masterdata/services/masterdata.service'
import ClientService from '../../../../clientmanagement/services/clientmanagement.service'
export default {
  name: 'changedefaulthub',
  components: {
    VueElementLoading,
    Paginate,
    Multiselect
  },
  props: [],
  data: function() {
    return {
      isLoading:false,
      adminsettingdata:[],
      HSNCode:"",
      StatesLimit:[],
      SelectedStates:'',
      exemptHSN:'',
      states:'',
      printstickeroptions:"",
      cft:'',
      hubaccess:[],
      hubaccessObjArray:[],
      currentHub:'',
      hubid:'',
      hubid1:'',
      isPalletScan:'',
      scanType:'',
      originhubids:null,
      destinationhubids:null,
      Clientlist:[],
      ClientBusinessAccountlist:[],
	  ClientOTPlist:[],
	  selectedOTPClients:[],
      selectedClients:[],
      selectedClientsForClientRefNo:[],
      selectedClientsForRefNo:[],
      selectedClientsForDisabledWt:[],
      selectedTables:[],
      ftccashlimit:"",
      emailrecipient:[],
      emailrecipientArray:[],
      GreenTaxPincodes:[],
      GreenTaxPincodesArray:[],
      prcutofftime:"",
      FTCAMterr:"",
      RolesList:[],
      roleId:'',
      rolename:'',
      autocutoffweight:"",
      autofetchdatalimit:"",
      prCutoofSelected:0,
      prCutoofBackspace:0,
	  mpsPrintDisabledClients:"",
	  OTPBasedDelivery:"",
	  ClientReferenceNolist:"",
	  ReferenceNolist:"",
	  ClientsForDisabledWt:"",
	  clientlist:[],
      ShowClientDetails:false,
	  clinetnamelist:"",
	ShowAwbCopy:false,
	ShowMpsCopy:false,
	ShowAwbCopyDetails:false,
	printcopy:'',
    ConsigneeCodeOnMps:"",
	clientdata:{},
	RelianceSecondaryClient:"",
	ProofOfPickup:"",
  ShowGlobalPickup:false,
  globalpickuppincodedataArray:[],
  globalpickup:'',
  pincode:[],
  ShowClientDetailsforglobalpickup:false,
  GlobalPickupClientPincodeData:{},
  disablesave:false,
  isDwsScanEnable:'',
	  dwshub:'',
    ShowGlobalDelivery:false,
    globaldeliverypincode:[],
    enableverification: "",
    prwtthreshold:500,
    blockclient: false,
    blockpickup : 0,
    blockdelivery : 0,
    blockclientreason:"",
    blockclientcode : {},
    globaldeliveryflag:'',
    encryptflag:0,
    clientbusinessaccountid:'',
    clientname:'',
    ftcsettlementlimit:"",
    ftctdsper: null,
    pendingpodpendencydays: 0,
    pendingPoderr:"",
    }
  },
  computed: {
  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.useremail = userdetail.email;
    this.currentHub = userdetail.hubID[0];
    await Promise.all([this.getStatelist(),this.loadAllHubAccessList(),this.getCompanyShortName(),this.getRoleList()]);
    await this.getAdminSettings();
  },
  methods: {
    isIntegerOnly: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    async onchange(id){
      try {
        this.isLoading = true;
        let payload ={
          username: this.useremail,
          hubid:id.hubid
        }
        let scandata = await AdminSettingsService.getAdminSettings(payload);
        if(scandata.data.code==200){
          this.adminsettingdata = scandata.data.data.settings;
          this.emailrecipient =  await this.getValueByKeyName('LHHANDOVERRECIPIENT');
        }
        if(scandata.data.data.hubdata){
          this.isPalletScan = scandata.data.data.hubdata.ispalletscan
          this.scanType = scandata.data.data.hubdata.scantype
		      this.isDwsScanEnable = scandata.data.data.hubdata.isdwsscanenable
        }else{
          this.isPalletScan=""
          this.scanType=""
		      this.isDwsScanEnable=""
        }
        this.isLoading = false;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    async loadAllHubAccessList() {
      try {
        let InputPayload = {};
      this.isLoading = true;
      let response = await MasterService.GetHublist(InputPayload);
      if(response.data.code===200){
        this.hubaccess = response.data.data.data;
        for (var i = 0; i < this.hubaccess.length; i++) {
          this.hubaccessObjArray.push({
            hubid: this.hubaccess[i].HubID,
            hubname: this.hubaccess[i].HubName
          })
        }
        let getcurrenthubobj = this.hubaccess.find(hubs => hubs.HubID == this.currentHub );
        this.hubid = { hubid: this.currentHub,hubname: getcurrenthubobj.HubName}
        this.hubid1 = { hubid: this.currentHub,hubname: getcurrenthubobj.HubName}
		    this.dwshub = { hubid: this.currentHub,hubname: getcurrenthubobj.HubName}
        let payload ={
          username: this.useremail,
          hubid:this.currentHub
        }
        let scandata = await AdminSettingsService.getAdminSettings(payload);
        if(scandata.data.data.hubdata){
          this.isPalletScan = scandata.data.data.hubdata.ispalletscan
          this.scanType = scandata.data.data.hubdata.scantype
		      this.isDwsScanEnable = scandata.data.data.hubdata.isdwsscanenable
         }
        }
        else {
          this.$alertify.error(response.data.message);
        }
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async getAdminSettings(){
      try {
        this.isLoading = true;
        let inputPayload = {
          username: this.useremail
        }
        let result = await AdminSettingsService.getAdminSettings(inputPayload);
        this.adminsettingdata = result.data.data.settings;
        let temproles = this.getValueByKeyName('PRQCONFIG');
        this.roleId=[];
        this.RolesList.forEach(item=>{
          if(temproles.includes(item.rolename)){
            this.roleId.push({
              'rolename': item.rolename
            })
          }
        })
        this.ftccashlimit = this.getValueByKeyName('FTCAMTLIMIT');
        this.pendingpodpendencydays = this.getValueByKeyName('PODPENDENCYDAYS');
        this.prcutofftime = this.getValueByKeyName('PRCUTOFFTIME').join(":");
        this.prwtthreshold = this.getValueByKeyName('PRWEIGHTTHRESHOLD')
        this.autocutoffweight = this.getValueByKeyName('CUTOFFWEIGHT');
        this.autofetchdatalimit = this.getValueByKeyName('FETCHDATALIMIT');
        this.globaldeliveryflag = this.getValueByKeyName('GLOBALDELIVERYFLAG')[0];
        this.encryptflag = this.getValueByKeyName('PIICONFIG').isencrypt[0];
        this.emailrecipient =  await this.getValueByKeyName('LHHANDOVERRECIPIENT');
        this.GreenTaxPincodes =  await this.getValueByKeyName('GREENTAXPINCODES');
        this.ftcsettlementlimit = await this.getValueByKeyName('FTCUNSETTLEDCASH');
        this.ftctdsper = await this.getValueByKeyName('FTCTDSPER');
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    getHubName(hubid) {
      for (var i = 0; i < this.hubaccessObjArray.length; i++) {
        if (this.hubaccessObjArray[i].hubid == hubid) {
          return this.hubaccessObjArray[i].hubname;
        }
      }
    },
    getValueByKeyName(key) {
      let keysvalue;
      for (var i = 0; i < this.adminsettingdata.length; i++) {
        if (this.adminsettingdata[i].key == key) {
          if(key=='LHHANDOVERRECIPIENT'){
            let valueData=this.adminsettingdata[i].value
            for(let el in valueData ){
              if(el==this.hubid.hubid){
                 keysvalue=valueData[el]
                return keysvalue
              }
            }
            return ""
          }
          return this.adminsettingdata[i].value;
        }
      }
    },
	async getStatelist(){
      try {
        this.StatesLimit = [];
        let result = await MasterService.getStateList();
        result.data.data.forEach(item=>{
          this.StatesLimit.push({
            'statename': item.statename.toUpperCase()
          })
        })
      }  catch(err){
        console.log(err);
      }
    },
    async getCompanyShortName(){
      try {
        let InputPayload = {};
        var CompanyShortList = [];
        let result = await ClientService.GetClientListByActiveContracts(InputPayload)
        CompanyShortList = result.data.data.rows;
        for (var i = 0; i < CompanyShortList.length; i++) {
          this.Clientlist.push({
            'clientId': CompanyShortList[i].clientid,
            'clientName': CompanyShortList[i].clientshortname,
          });

          this.ClientBusinessAccountlist.push({
            'clientId': CompanyShortList[i].clientbusinessaccountid,
            'clientName': CompanyShortList[i].clientshortname,
          });
		      this.ClientOTPlist.push({
			      'clientId':CompanyShortList[i].clientid,
            'clientBusinessAccountId': CompanyShortList[i].clientbusinessaccountid,
            'clientName': CompanyShortList[i].clientshortname,
          });
        }
      } catch(err){
        console.log(err);
      }
    },
    async saveAdminSettings(module,field){
      try {
        this.isLoading = true;
        let inputPayload = {
          username: this.useremail,
        }
        if (module == "flm") {
          if(field == "TripShipmentScan"){
          inputPayload.hubid = this.hubid.hubid;
          inputPayload.scantype = this.scanType;
          inputPayload.hubname = this.hubid.hubname;
          }
          if(field=="TripPalletScan"){
          inputPayload.ispalletscan = this.isPalletScan;
          inputPayload.hubname = this.hubid.hubname;
          }
          if(field=="EnableDWSScan"){
		      inputPayload.isdwsscanenable = parseInt(this.isDwsScanEnable);
          inputPayload.hubname = this.hubid.hubname;
          }
          if(field=="PickupRequest"){
          let roles = this.roleId.map(el=>el.rolename);
          inputPayload.roles = roles
          }
          if(field=='FTCCashCollect'){
            if(this.checkErr()){
              return false
            }else{
              inputPayload.ftccashlimit = this.ftccashlimit;  // disabling it temp
            }
          }
       if(field=='Emailrecipient'){
          inputPayload.emailrecipient=this.emailrecipient
          inputPayload.hubid = this.hubid.hubid;
        }
        if(field=='GreenTaxPincodes'){
          inputPayload.greentaxpincodes=this.GreenTaxPincodes;
        }
        if(field=='PRQCutoff'){
          if (this.prcutofftime && this.prcutofftime.length == 5) {
            inputPayload.prcutofftime = this.prcutofftime.split(":")
          }
        }
        if(field=='PRQWeightThreshold'){
          if (this.prwtthreshold) {
            if (Array.isArray(this.prwtthreshold) && this.prwtthreshold.length) {
              inputPayload.prwtthreshold = [this.prwtthreshold[0]]
            } else if (!Array.isArray(this.prwtthreshold)) {
              inputPayload.prwtthreshold = [this.prwtthreshold]
            }
          } else {
            this.isLoading = false;
            return false
          }
        }
          if(field=='AutoAllocWeight'){
          if (this.autocutoffweight) {
            inputPayload.autocutoffweight = [Number(this.autocutoffweight)];
          }
        }
        if(field=='AutoAllocLimit'){
          if (this.autofetchdatalimit) {
            inputPayload.autofetchdatalimit = [Number(this.autofetchdatalimit)];
          }
        }
        if(field=='globaldel'){
          if (this.globaldeliveryflag) {
            inputPayload.globaldeliveryflag=[Number(this.globaldeliveryflag)];
          }
        }
        if(field=='globalencryption'){
          if (this.encryptflag) {
            inputPayload.globalencryptionflag=[Number(this.encryptflag)];
           }
         }
        if(field=='ftcsettlementlimit'){
          if (this.ftcsettlementlimit) {
            inputPayload.ftcsettlementlimit=[Number(this.ftcsettlementlimit)];
           }
         }
        if(field=='ftctdsper'){
          if (this.ftctdsper) {
            inputPayload.ftctdsper=[Number(this.ftctdsper)];
           }
         }
        }
        if (field == 'PODPENDENCYDAYS') {
          if(this.checkPendingPodErr()){
            return false
          }else{
            inputPayload.pendingpodpendencydays = Number(this.pendingpodpendencydays)  // disabling it temp
          }
        }
        let result = await AdminSettingsService.saveAdminSettings(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
		      await this.getAdminSettings();
          this.$alert(result.data.message, "", "success");
        }else{
          this.$alert(result.data.message, "", "error");
        }
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
	  prcutOffcheck(event) {
    let keyList=['Backspace', ':','1', '2', '3', '4', '5', '6', '7', '8', '9', '0']
    if (keyList.includes(event.key)) {

      if (this.prCutoofSelected > 1) {
        this.prCutoofSelected = this.prCutoofSelected - 1;
        return;
      }
      if (this.prCutoofBackspace > 1) {
        this.prCutoofBackspace = this.prCutoofBackspace - 1;
        return;
      }
      if (event.key != 'Backspace') {
        this.prCutoofBackspace = 0
        let regNum = /^[0-9]+$/;
        if (this.prcutofftime && !this.prcutofftime[this.prcutofftime.length - 1].match(regNum)) {
          this.prcutofftime = this.prcutofftime.slice(0, -1);
        }
        const value = this.prcutofftime.replace(/[^0-9]/g, "");
        if (value.length > 2) {
          this.prcutofftime = value.slice(0, 2) + ":" + value.slice(2);
        } else if (value.length == 2) {
          this.prcutofftime = value.slice(0, 2) + ":";
        }

        let prCutoffsplit = this.prcutofftime.split(":");
        if (prCutoffsplit[0] && prCutoffsplit[0].length == 2 && (Number(prCutoffsplit[0]) < 0 || Number(prCutoffsplit[0]) > 23)) {
          prCutoffsplit[0] = "00";
          this.prcutofftime = prCutoffsplit.join(":");
        }
        if (prCutoffsplit[1] && prCutoffsplit[1].length == 2 && (Number(prCutoffsplit[1]) < 0 || Number(prCutoffsplit[1]) > 59)) {
          prCutoffsplit[1] = "00";
          this.prcutofftime = prCutoffsplit.join(":");
        }
      } else {
        this.prCutoofBackspace = this.prCutoofBackspace + 1
      }
    }else {
      if (!this.prcutofftime[this.prcutofftime.length-1].match(/\d|\:/) ) {
        this.prcutofftime = this.prcutofftime.slice(0, -1);
      }
    }
	},
  selectedPR(event){
    this.prCutoofSelected =  event.target.selectionEnd - event.target.selectionStart;
    if (this.prCutoofSelected>2) {
      this.prCutoofSelected = 0
    }
  },
    checkErr(){
      let err = false
      if(this.ftccashlimit == "" ||this.ftccashlimit==null){
        err = true
        this.FTCAMterr = "please enter FTC cash collect limit"
      }
      return err
    },
    checkPendingPodErr() {
      let err = false
      if(this.pendingpodpendencydays == "" ||this.pendingpodpendencydays==null){
        err = true
        this.pendingPoderr = "Please Enter Pending Pod Pendancy Days"
      }
      return err
    },
    async getRoleList(){
      try {
        this.isLoading = true;
        this.RolesList = [];
        let result = await MasterService.getRolesList();
        this.isLoading = false;
        if (result.data.code == 200) {
          result.data.data.rows.forEach(item=>{
              this.RolesList.push({
                'rolename':item.rolename
              });
          })
        }else {
          this.rolesList = [];
          this.$alert("Internal Server Error",'Admin Setting', "error");
        }
      }  catch(err){
        console.log(err);
      }
    },
    saveEmailData(){
		  try {
			  this.isLoading = true;
        this.emailrecipientArray=this.emailrecipient.toString().split(",")
        this.emailrecipient=this.emailrecipientArray
        this.isLoading = false;
				this.saveAdminSettings('flm','Emailrecipient');
		  } catch (error) {
			  this.isLoading = false;
			  console.log(error);
		  }
	  },
    saveGreenTaxPincodeData(){
		  try {
        this.$validator.validateAll("greentaxpincodeform").then((result) => {
          if (result) {
            this.isLoading = true;
            let GreenTaxPincodesArray = (this.GreenTaxPincodes)?this.GreenTaxPincodes.toString().split(","):[];
            this.GreenTaxPincodesArray = GreenTaxPincodesArray.filter(item => item !== "");
            this.GreenTaxPincodes=this.GreenTaxPincodesArray
            this.isLoading = false;
    				this.saveAdminSettings('flm','GreenTaxPincodes');
          }
        }).catch(() => {
          console.log('errors exist');
          return false;
        });
		  } catch (error) {
			  this.isLoading = false;
			  console.log(error);
		  }
	  },
    isArrayEqualNaN(arr) {
      if (!Array.isArray(arr)) {
        return false; // Not an array
      }
      if (arr.length !== 1) {
        return false; // Array length is not 1
      }
      return isNaN(arr[0]);
    },
    saveFtcConfig(field){
      this.$validator.validateAll("ftcform").then((result) => {
        if (result) {
          this.isLoading = true;
          this.saveAdminSettings('flm',field);
        }
      }).catch(() => {
        console.log('errors exist');
        this.isLoading = false;
        return false;
      });
    }
  }
}
Validator.extend('verify_prcutoff', {
  getMessage: field => "Invalid PR Cut-Off time entered.",
  validate: value => {
    var PRCutofftime = $("#prcutofftime").val();
    if (PRCutofftime.length!=5) {
      return false
    }
    let PRCutoff=PRCutofftime.split(":");
    if (PRCutoff[0].length== 2 && PRCutoff[1].length== 2) {
      return true;
    } else{
      return false;
    }
  }
});
Validator.extend('verify_pincode', {
  getMessage: field => "The Pincode field format is invalid",
  validate: value => {
    if ( value.match(/^\d{6}(,\d{6})*$/)) {
      this.disablesave=false
    return true
    }else{
      this.disablesave=true
      return false;
    }
  }
});
Validator.extend('verify_floatvalue', {
  getMessage: field => "The format should be number with upto two decimal",
  validate: value => {
  const valueString = value.toString();
  const regex = /^\d+(\.\d{1,2})?$/;

  return regex.test(valueString);
  }
});



// WEBPACK FOOTER //
// ./src/modules/adminsettings/views/configuration/FLMConfiguration/flmconfiguration.component.js